import App from "antd/es/app";

export const useMessage = () => {
  const { message } = App.useApp();

  return message;
};
